import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const STORAGE_KEY = "APP_CONTEXT";

const useClearContextOnRoot = (clearAll = false) => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      if (clearAll) {
        sessionStorage.clear();
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    }
  }, [location.pathname, clearAll]);
};

export default useClearContextOnRoot;
